import ShoppingListConnector from './shoppingList.props';
import ShoppingListComponent from './shoppingList.component';
import setupLogPrintListener from '../../helpers/Print';

/**
 * Add a print event listener to the DOM and send analytics so we know how many ppl print
 */
setupLogPrintListener();

export default ShoppingListConnector(ShoppingListComponent);
